export enum ReportView {
  CANADA_VIEW = 'canada',
  CRIMINAL_VIEW = 'criminal',
  CLEARINGHOUSE_VIEW = 'clearinghouse',
  DRUG_ALCOHOL_CLEARINGHOUSE_VIEW = 'drug_alcohol_clearinghouse',
  DRIVER_SCREENINGS_VIEW = 'driver_screenings',
  HEALTH_VIEW = 'health',
  CREDIT_VIEW = 'credit',
  SELF_DISCLOSURE_VIEW = 'self_disclosure',
  INTERNATIONAL_VIEW = 'international',
  PLV_VIEW = 'professional_license_verification',
  PLV_SUMMARY_VIEW = 'professional_license_verification_summary',
}

const TOGGLE_SCREENINGS = [
  'creditReport',
  'drugScreening',
  'occupationalHealthScreening',
  'clearinghouseSearch',
  'professionalLicenseVerifications',
  'drugAlcoholClearinghouse',
  'fmcsaPreEmploymentScreeningProgram',
];

const {
  CANADA_VIEW,
  CRIMINAL_VIEW,
  CLEARINGHOUSE_VIEW,
  DRUG_ALCOHOL_CLEARINGHOUSE_VIEW,
  DRIVER_SCREENINGS_VIEW,
  HEALTH_VIEW,
  CREDIT_VIEW,
  SELF_DISCLOSURE_VIEW,
  INTERNATIONAL_VIEW,
  PLV_VIEW,
  PLV_SUMMARY_VIEW,
} = ReportView;

const CLEAR_STATUS = 'clear';
const CONSIDER_STATUS = 'consider';
const DISPUTE_STATUS = 'dispute';
const SUSPENDED_STATUS = 'suspended';
const PENDING_STATUS = 'pending';
const CANCELED_STATUS = 'canceled';
const COMPLETE_STATUS = 'complete';

const COMPLETE_STATUSES = [CLEAR_STATUS, CONSIDER_STATUS, COMPLETE_STATUS];
const PROCESSING_STATUSES = [PENDING_STATUS, SUSPENDED_STATUS];

const SEARCH_TYPE = {
  SSN_TRACE: 'SSN Trace',
  CIVIL_SEARCH: 'Civil Search',
  SEX_OFFENDER_SEARCH: 'Sex Offender Search',
  GLOBAL_WATCHLIST_SEARCH: 'Global Watchlist Search',
  HEALTHCARE_SANCTIONS_SEARCHES: 'Healthcare Sanctions Searches',
  INTERNATIONAL_SEARCH: 'International Search',
  ARREST_SEARCH: 'Arrest Search',
  NATIONAL_SEARCH: 'National Search',
  STATE_SEARCHES: 'State Searches',
  POINTER_STATE_SEARCHES: 'Pointer State Searches',
  FEDERAL_SEARCH: 'Federal Search',
  FEDERAL_DISTRICT_SEARCHES: 'Federal District Searches',
  FEDERAL_DISTRICT_CIVIL_SEARCHES: 'Federal District Civil Searches',
  FEDERAL_CIVIL_SEARCH: 'Federal Civil Search',
  COUNTY_SEARCHES: 'County Searches',
  COUNTY_CIVIL_SEARCHES: 'County Civil Searches',
  MUNICIPAL_SEARCHES: 'Municipal Searches',
  CHILD_ABUSE_SEARCHES: 'Child Abuse Searches',
  DRUG_ALCOHOL_CLEARINGHOUSE: 'Drug Alcohol Clearinghouse',
  FMCSA_PRE_EMPLOYMENT_SCREENING_PROGRAM:
    'FMCSA Pre-Employment Screening Program',
  MOTOR_VEHICLE_REPORT: 'Motor Vehicle Report',
  EMPLOYMENT_VERIFICATION: 'Employment Verification',
  EDUCATION_VERIFICATION: 'Education Verification',
  PERSONAL_REFERENCE_VERIFICATION: 'Personal Reference Verification',
  PROFESSIONAL_REFERENCE_VERIFICATION: 'Professional Reference Verification',
  ABUSE_REGISTRY_SEARCH: 'Abuse Registry Search',
  SAFETY_ALLIANCE_SEARCH: 'Safety Alliance Search',
  SOCIAL_MEDIA_SCREENING: 'Social Media Search',
  FACIS: 'FACIS',
  CLEARINGHOUSE_SEARCH: 'Clearinghouse Search',
  PROFESSIONAL_LICENSE_VERIFICATION: 'Professional License Verification',
  INTERNATIONAL_ADVERSE_MEDIA_SEARCHES: 'International Adverse Media Searches',
  INTERNATIONAL_CRIMINAL_SEARCHES: 'International Criminal Searches',
  INTERNATIONAL_CANADA_BC_ENHANCED_CRIMINAL_SEARCH:
    'International Canada BC Enhanced Criminal Search',
  INTERNATIONAL_GLOBAL_WATCHLIST: 'International Global Watchlist',
  INTERNATIONAL_EDUCATION_VERIFICATION: 'International Education Verification',
  INTERNATIONAL_EMPLOYMENT_VERIFICATION:
    'International Employment Verification',
  INTERNATIONAL_IDENTITY_DOCUMENT_VALIDATION:
    'International Identity Document Validation',
  INTERNATIONAL_MOTOR_VEHICLE_REPORT: 'International Motor Vehicle Report',
  INTERNATIONAL_RIGHT_TO_WORK: 'International Right To Work',
  INTERNATIONAL_CREDIT_REPORT: 'International Credit Report',
};

const SEARCHES = {
  [SEARCH_TYPE.SSN_TRACE]: 'ssnTrace',
  [SEARCH_TYPE.CIVIL_SEARCH]: 'evictionSearch',
  [SEARCH_TYPE.SEX_OFFENDER_SEARCH]: 'sexOffenderSearch',
  [SEARCH_TYPE.GLOBAL_WATCHLIST_SEARCH]: 'terroristWatchlistSearch',
  [SEARCH_TYPE.HEALTHCARE_SANCTIONS_SEARCHES]: 'healthcareSanctionsSearches',
  [SEARCH_TYPE.INTERNATIONAL_SEARCH]: 'internationalCriminalSearches',
  [SEARCH_TYPE.ARREST_SEARCH]: 'arrestSearch',
  [SEARCH_TYPE.NATIONAL_SEARCH]: 'nationalCriminalSearch',
  [SEARCH_TYPE.STATE_SEARCHES]: 'stateCriminalSearches',
  [SEARCH_TYPE.POINTER_STATE_SEARCHES]: 'pointerStateCriminalSearches',
  [SEARCH_TYPE.FEDERAL_SEARCH]: 'federalCriminalSearch',
  [SEARCH_TYPE.FEDERAL_DISTRICT_SEARCHES]: 'federalDistrictCriminalSearches',
  [SEARCH_TYPE.FEDERAL_DISTRICT_CIVIL_SEARCHES]: 'federalDistrictCivilSearches',
  [SEARCH_TYPE.FEDERAL_CIVIL_SEARCH]: 'federalCivilSearch',
  [SEARCH_TYPE.COUNTY_SEARCHES]: 'countyCriminalSearches',
  [SEARCH_TYPE.COUNTY_CIVIL_SEARCHES]: 'countyCivilSearches',
  [SEARCH_TYPE.MUNICIPAL_SEARCHES]: 'municipalCriminalSearches',
  [SEARCH_TYPE.CHILD_ABUSE_SEARCHES]: 'childAbuseSearches',
  [SEARCH_TYPE.DRUG_ALCOHOL_CLEARINGHOUSE]: 'drugAlcoholClearinghouse',
  [SEARCH_TYPE.FMCSA_PRE_EMPLOYMENT_SCREENING_PROGRAM]:
    'fmcsaPreEmploymentScreeningProgram',
  [SEARCH_TYPE.MOTOR_VEHICLE_REPORT]: 'motorVehicleReport',
  [SEARCH_TYPE.EMPLOYMENT_VERIFICATION]: 'employmentVerification',
  [SEARCH_TYPE.EDUCATION_VERIFICATION]: 'educationVerification',
  [SEARCH_TYPE.PERSONAL_REFERENCE_VERIFICATION]:
    'personalReferenceVerifications',
  [SEARCH_TYPE.PROFESSIONAL_REFERENCE_VERIFICATION]:
    'professionalReferenceVerifications',
  [SEARCH_TYPE.ABUSE_REGISTRY_SEARCH]: 'abuseRegistrySearch',
  [SEARCH_TYPE.SAFETY_ALLIANCE_SEARCH]: 'safetyAllianceSearch',
  [SEARCH_TYPE.SOCIAL_MEDIA_SCREENING]: 'socialMediaScreenings',
  [SEARCH_TYPE.FACIS]: 'facisSearch',
  [SEARCH_TYPE.CLEARINGHOUSE_SEARCH]: 'clearinghouseSearch',
  [SEARCH_TYPE.PROFESSIONAL_LICENSE_VERIFICATION]:
    'professionalLicenseVerifications',
  [SEARCH_TYPE.INTERNATIONAL_ADVERSE_MEDIA_SEARCHES]:
    'internationalAdverseMediaSearches',
  [SEARCH_TYPE.INTERNATIONAL_CRIMINAL_SEARCHES]:
    'internationalCriminalSearchesV2',
  [SEARCH_TYPE.INTERNATIONAL_CANADA_BC_ENHANCED_CRIMINAL_SEARCH]:
    'internationalCanadaBcEnhancedCriminalSearch',
  [SEARCH_TYPE.INTERNATIONAL_GLOBAL_WATCHLIST]:
    'internationalGlobalWatchlistSearch',
  [SEARCH_TYPE.INTERNATIONAL_EDUCATION_VERIFICATION]:
    'internationalEducationVerification',
  [SEARCH_TYPE.INTERNATIONAL_EMPLOYMENT_VERIFICATION]:
    'internationalEmploymentVerification',
  [SEARCH_TYPE.INTERNATIONAL_IDENTITY_DOCUMENT_VALIDATION]:
    'internationalIdentityDocumentValidation',
  [SEARCH_TYPE.INTERNATIONAL_MOTOR_VEHICLE_REPORT]:
    'internationalMotorVehicleReport',
  [SEARCH_TYPE.INTERNATIONAL_RIGHT_TO_WORK]: 'internationalRightToWork',
  [SEARCH_TYPE.INTERNATIONAL_CREDIT_REPORT]: 'internationalCreditReport',
};

const UPDATE_PERSONAL_INFO_DISABLED_ACCOUNT_URIS = [
  'uber',
  'uberblack',
  'uber_eats',
  'amazon',
  'amazon-dsp',
  'amazon-omega',
];

export {
  CANADA_VIEW,
  CANCELED_STATUS,
  CLEAR_STATUS,
  CLEARINGHOUSE_VIEW,
  COMPLETE_STATUS,
  COMPLETE_STATUSES,
  CONSIDER_STATUS,
  CREDIT_VIEW,
  CRIMINAL_VIEW,
  DISPUTE_STATUS,
  DRUG_ALCOHOL_CLEARINGHOUSE_VIEW,
  DRIVER_SCREENINGS_VIEW,
  HEALTH_VIEW,
  PENDING_STATUS,
  PROCESSING_STATUSES,
  SUSPENDED_STATUS,
  SEARCHES,
  SEARCH_TYPE,
  SELF_DISCLOSURE_VIEW,
  INTERNATIONAL_VIEW,
  PLV_VIEW,
  PLV_SUMMARY_VIEW,
  UPDATE_PERSONAL_INFO_DISABLED_ACCOUNT_URIS,
  TOGGLE_SCREENINGS,
};
